<template>
  <div class="p-relative">
    <div
      :class="[{ '--has-more': hasMore }, 'post-attachment']"
      @click="handleClick"
    >
      <template v-if="isFetching">
        <div class="d-flex justify-content-center py-5 opacity-30">
          <v-loader />
        </div>
      </template>
      <template v-else>
        <blocks-container
          ref="blocks-container"
          :blocks="blocks"
          :page-id="pageId"
          limit="3"
          :ignore-blocks="ignoreBlocks"
        />
      </template>
    </div>
    <v-button
      v-if="hasMore"
      raised
      light
      small
      class="post-attachment__more-button"
      @click="goToAttachment"
    >
      {{ $t("components.messageThread.postAttachment.viewMore") }}
    </v-button>
  </div>
</template>

<script>
import { mapMutations } from "vuex"

import { BLOCK_TYPES } from "@/lib/stream-utils"
import { QUERY_PARAMS } from "@/lib/messages-utils"
import { isPresent, eventPath } from "@/lib/utils"
import fetchPageData from "@/lib/fetch-page-data"

import BlocksContainer from "@/components/stream/BlocksContainer"

const IGNORED_CLICK_ELEMENTS = ["A", "BUTTON", "CANVAS"]

export default {
  components: {
    BlocksContainer
  },

  props: {
    message: { type: Object, default: () => {} },
    attachment: { type: Object, default: () => {} }
  },

  computed: {
    ignoreBlocks() {
      return [BLOCK_TYPES.WORKOUT_BLOCK, BLOCK_TYPES.CHAT_BLOCK]
    }
  },

  data() {
    return {
      isFetching: false,
      hasMore: false,
      blocks: [],
      pageId: null
    }
  },

  mounted() {
    this.isFetching = true

    // TODO: Handle if no attachment path
    fetchPageData(this.attachment.path)
      .then(({ props }) => {
        this.pageId = props.page_id
        this.blocks = props.blocks

        this.setPageAttributeValues({
          pageId: props.page_id,
          values: props.attribute_values
        })

        setTimeout(() => {
          this.calculateHasMore()
        }, 100)
      })
      .finally(() => {
        this.isFetching = false
      })
  },

  methods: {
    ...mapMutations("pages", ["setPageAttributeValues"]),

    handleClick(e) {
      if (
        eventPath(e).find(el => IGNORED_CLICK_ELEMENTS.includes(el.tagName))
      ) {
        return
      }

      this.goToAttachment()
    },

    goToAttachment() {
      const path = isPresent(this.message.reply_thread_id)
        ? this.attachment.path +
          `?${QUERY_PARAMS.SHOW_THREAD}=${this.message.reply_thread_id}`
        : this.attachment.path

      this.$router.push(path)
    },

    calculateHasMore() {
      if (this.blocks.length > 3) {
        this.hasMore = true
      } else {
        const blocksContainer = this.$refs["blocks-container"]
        const blocksContainerHeight = blocksContainer.$el.offsetHeight

        this.hasMore = blocksContainerHeight > 600
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

$post-attachment--max-height: 600px;

.post-attachment {
  --app-height-initial: calc(
    #{$post-attachment--max-height} + env(safe-area-inset-top)
  );

  color: $color-ui--grey-90;
  max-height: $post-attachment--max-height;
  overflow: hidden;

  &.--has-more {
    mask-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0) 0%,
      rgb(255, 255, 255) 12%
    );
  }
}

.post-attachment__more-button {
  position: absolute;
  bottom: $size--4;
  left: 50%;
  margin-left: -52px;
}
</style>
